import DatiUtente from "../../DatiUtente/DatiUtente";
import { RichiestaService } from "../../../../services/RichiestaService";

const Step1 = (props) => {
  const nextBtnFunction = props.nextBtnFunction;
  const afterSubmitFunction = props.afterSubmitFunction;

  const richiestaService = new RichiestaService();

  const onNextBtnClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (nextBtnFunction) nextBtnFunction();
  };

  const propagateSave = (result) => {
    if (afterSubmitFunction) afterSubmitFunction(result);
    if (nextBtnFunction) nextBtnFunction();
  };

  return (
    <>
      <DatiUtente
        title={'Dati del richiedente'}
        toastMessage={'Dati del richiedente salvati'}
        skipNavigate
        nextStep={() => onNextBtnClick()}
        propagateSave={(result) => propagateSave(result)}
        salvaLabel={'Salva e vai avanti'}
        dbData={props.richiesta?.richiestaDatiRichiedente}
        service={richiestaService.saveStep1}
        idRichiesta={props.richiesta?.id}
        saveOnlyOnEdit
        disabled={!!props.richiesta?.richiestaDatiRichiedente}
        onChangedValue={() => props.onChangedValue()}
        propagateComuni={(comuni) => props.propagateComuni(comuni)}
        nazioni={props.nazioni}
      />
    </>
  );
};

export default Step1;
